import { applyRuntimeOverrides } from './runtime-config';

// The values below are the compiled-in defaults. In the Docker image they are
// overridden at runtime by /env.js, rendered from the container environment
// (see frontend/docker/40-render-env.sh and runtime-config.ts).
export const environment = applyRuntimeOverrides({
  production: false,
  environmentLabel: 'STAGING',
  auth: {
    identityServerUrl: 'https://auth.nrg.synergyvalue.eu/',
    clientId: 'nrg-front',
    realm: 'NRG'
  },
  apiUrl: 'https://api.nrg.synergyvalue.eu/api',
  photoUpload: {
    storagePath: 'uploads/photos',
    maxFileSizeBytes: 31457280, // 30MB
    allowedFileTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
    maxImageWidth: 80000,
    maxImageHeight: 80000,
    jpegQuality: 85
  }
});
